import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';

const C = {
  purple: '#552583',
  gold:   '#FDB927',
  bg:     '#E4F0F6',
  white:  '#ffffff',
  text:   '#1a1a1a',
  soft:   '#4a4a4a',
  muted:  '#7a7a7a',
};

const SECTIONS = [
  {
    title: 'Notre engagement',
    content: "Usafiri s'engage à rendre son application mobile et son site web accessibles au plus grand nombre, conformément aux recommandations d'accessibilité numérique.",
  },
  {
    title: 'Fonctionnalités d\'accessibilité',
    content: "L'application Usafiri prend en charge les technologies d'assistance natives d'iOS et Android : VoiceOver (iOS), TalkBack (Android), taille de texte dynamique, contraste élevé et navigation au clavier. Tous les boutons et éléments interactifs disposent d'étiquettes accessibles.",
  },
  {
    title: 'Contenu de l\'application',
    content: "Usafiri ne contient pas de contenu pour adultes, de jeux d'argent, de contenus médicaux sensibles ni de contenus générés par les utilisateurs non modérés. L'application est destinée à tous les publics à partir de 4 ans.",
  },
  {
    title: 'Chiffrement et sécurité',
    content: "L'application utilise uniquement le chiffrement standard fourni par iOS et Android (HTTPS/TLS) pour sécuriser les communications. Elle n'implémente pas d'algorithme de chiffrement propriétaire ou non standard (ITSAppUsesNonExemptEncryption : false).",
  },
  {
    title: 'Signalement d\'un problème d\'accessibilité',
    content: "Si vous rencontrez une difficulté d'accessibilité sur notre application ou notre site, contactez-nous à contact@usafiri.yt. Nous nous engageons à traiter votre demande dans un délai de 5 jours ouvrés.",
  },
  {
    title: 'Contact',
    content: 'Pour toute question relative à l\'accessibilité : contact@usafiri.yt — Usafiri, Mayotte, France.',
  },
];

export default function Accessibilite() {
  return (
    <Box sx={{ backgroundColor: C.bg, minHeight: '100vh' }}>

      <Box sx={{ backgroundColor: C.purple, py: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Container maxWidth="md">
          <AccessibilityNewIcon sx={{ fontSize: 48, color: C.gold, mb: 2 }} />
          <Typography variant="h3" fontWeight={800} color="#fff" sx={{ fontSize: { xs: '1.8rem', md: '2.4rem' }, mb: 1.5 }}>
            Accessibilité
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
            Déclaration d'accessibilité de l'application et du site Usafiri
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Box sx={{ backgroundColor: C.white, borderRadius: '16px', border: '1px solid #e8e8e8', overflow: 'hidden' }}>
          {SECTIONS.map((s, i) => (
            <Box key={i}>
              <Box sx={{ px: 4, py: 3.5 }}>
                <Typography fontWeight={700} sx={{ color: C.purple, mb: 1, fontSize: '1rem' }}>
                  {s.title}
                </Typography>
                <Typography sx={{ color: C.soft, fontSize: '0.9rem', lineHeight: 1.7 }}>
                  {s.content}
                </Typography>
              </Box>
              {i < SECTIONS.length - 1 && <Divider />}
            </Box>
          ))}
        </Box>

        <Typography sx={{ color: C.muted, fontSize: '0.8rem', textAlign: 'center', mt: 4 }}>
          Dernière mise à jour : juillet 2025
        </Typography>
      </Container>

    </Box>
  );
}
